import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { Button, Sheet, SheetContent, SheetTrigger } from '~/components';
import { PartnerMarketplacesSheet } from '~/module/pack/partner-marketplaces-sheet';

export function GetFinishedSaleOnMarketButton() {
  const t = useTranslations('directSale');
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className="w-full"
      onClick={(event) => {
        event.stopPropagation();
        event.preventDefault();
      }}
    >
      <Sheet open={isOpen} onOpenChange={setIsOpen}>
        <SheetTrigger asChild>
          <Button className="h-11 whitespace-nowrap" variant="dark-bordered">
            {t('btn-get-on-market')}
          </Button>
        </SheetTrigger>
        <SheetContent className="rounded-t-3xl">
          <PartnerMarketplacesSheet />
        </SheetContent>
      </Sheet>
    </div>
  );
}
